import {joinURIComponents} from 'polyphony/util';

export const getWPJSON = (rest_route, args) =>
    fetch("/?" + joinURIComponents({rest_route, ...args}),
          {headers: {'X-WP-Nonce': polyphony.getState().nonce}}).then(x => x.json());

export const postWPJSON = (rest_route, args) =>
    fetch("/?" + joinURIComponents({rest_route}),
          {headers: {'X-WP-Nonce': polyphony.getState().nonce},
           body: JSON.stringify(args),
           method: 'POST'}).then(x => x.json());

export const getAttachment = attachment_id =>
    getWPJSON("/polyphony/v1/get_attachment/", {attachment_id});

export const wpQuery = (path, xs = {}) =>
    getWPJSON("/polyphony/v1/wp-query/", {path, ...xs});

